import axios from "axios";
const jsonConfig = require("../../Config.json");

const vetteststatusupdate = async (payload) => {

    let allResponse = {}
    try {
        allResponse = await axios.post(`${jsonConfig.apiUrl}vetteststatusupdate`,payload, {
            headers: {
                "x-functions-key": jsonConfig.key,
            }
        });

        return Promise.resolve(allResponse)

    } catch (error) {
        return Promise.reject(error)
    }
}

export default vetteststatusupdate
